import APIService from '@/services/api-service'
const resource = '/participant'

class ParticipantService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public saveParticipants (data: any) {
    return this.connector.post(`${resource}/save`, data)
  }

  public getParticipants (companyId: number) {
    return this.connector.get(`${resource}/${companyId}/all`)
  }

  public deleteParticipant (id: number) {
    return this.connector.delete(`${resource}/${id}/delete`)
  }
}

export default new ParticipantService()
